import ConsumptionReport from '../components/ConsumptionReport';
import { theoreticalConfig } from '../configs/theoreticalConfig';

const TheoreticalConsumption = ( { outlets }) => {
  return (
    <ConsumptionReport {...theoreticalConfig} outlets={outlets} />
  );
};

export default TheoreticalConsumption;
